import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Box,
    CircularProgress,
    Typography,
    Button,
    Stack
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';

const LearnerQRModal = ({ open, onClose, qrImage, qrLoading,user }) => {
    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = qrImage;
        link.download = `${user?.learner?.name?.split(' ')?.join('')}_${user?.learner?.email}.png`; // or .jpg based on your image format
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
        >
            <DialogTitle>
                <strong>Learner QR</strong>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{ position: 'absolute', right: 8, top: 8 }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                {qrLoading ? (
                    <Box display="flex" justifyContent="center" alignItems="center" height="200px">
                        <CircularProgress />
                    </Box>
                ) : qrImage ? (
                    <Stack spacing={2} alignItems="center">
                        <Box
                            component="img"
                            src={qrImage}
                            alt="QR Code"
                            sx={{
                                width: '100%',
                                maxWidth: '400px',
                                height: 'auto',
                                maxHeight: '400px',
                                objectFit: 'contain',
                                display: 'block',
                                border: '1px solid #ccc',
                                borderRadius: '8px',
                            }}
                        />
                        <Button
                            variant="contained"
                            startIcon={<DownloadIcon />}
                            onClick={handleDownload}
                        >
                            Download QR
                        </Button>
                    </Stack>
                ) : (
                    <Typography>No QR code available</Typography>
                )}
            </DialogContent>
        </Dialog>
    );
};

export default LearnerQRModal;
